import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Dialog,
  FlatButton,
  TextField
} from 'material-ui';

const styles = {
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    actionsContainer: {
      display: 'flex',
      padding: '0',
    },
    buttonLabel: {
      color: '#FFFFFF',
    },
    button: {
      borderRadius: '0',
      width: '50%'
    },
}

export default class AlertDialog extends Component {
  constructor(props){
    super(props);
    this.state = {
      open: true,
      comment: "",
      errorMessage: ""
    };
  }

  handleConfirm = () => {
    if(this.props.mandatoryComment && this.state.comment === ""){
      this.setState({errorMessage: 'Es obligatorio que escribas algo en este campo'})
    }
    else {
      this.props.confirm();
      this.handleClose();
    }
  };

  handleCancel = () => {
    this.props.cancel();
    this.handleClose();
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  handleChange = (event) => {
    this.props.handleCommentChange(event)
    this.setState({comment: event.target.value})
  }

  render() {
    const actions = [
      <FlatButton
        label='Cancelar'
        primary={true}
        onClick={this.handleCancel}
        backgroundColor='#ba0f0f'
        labelStyle={styles.buttonLabel}
        hoverColor='#eab6b8'
        style={styles.button}
      />,
      <FlatButton
        label='Aceptar'
        primary={true}
        onClick={this.handleConfirm}
        backgroundColor='#11AB99'
        labelStyle={styles.buttonLabel}
        hoverColor='#89d6c7'
        style={styles.button}
      />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={true}
          open={this.state.open}
          actionsContainerStyle={styles.actionsContainer}
        >
          <div style={styles.contentContainer}>
            <h3>{this.props.message}</h3>
            <TextField
              value={this.state.comment}
              onChange={this.handleChange}
              fullWidth={!this.props.email}
              hintText="Escriba aquí"
              multiLine={!this.props.email}
              maxRows={this.props.email ? 1 : 6}
              errorText={this.state.errorMessage}
            />
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/design/AlertDialogWithComments.js